"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetView$ = exports.StreetView$outboundSchema = exports.StreetView$inboundSchema = void 0;
exports.streetViewToJSON = streetViewToJSON;
exports.streetViewFromJSON = streetViewFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const coordinates_js_1 = require("./coordinates.js");
/** @internal */
exports.StreetView$inboundSchema = z.object({
    building_point: z.nullable(coordinates_js_1.Coordinates$inboundSchema),
    distance_from_street_point: z.nullable(z.number()),
    image_date: z.nullable(z.string()),
    image_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    pano_id: z.nullable(z.string()),
    property_bearing: z.nullable(z.number()),
    street_point: z.nullable(coordinates_js_1.Coordinates$inboundSchema),
    street_view_coordinates: z.nullable(coordinates_js_1.Coordinates$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "building_point": "buildingPoint",
        "distance_from_street_point": "distanceFromStreetPoint",
        "image_date": "imageDate",
        "image_expiry_date": "imageExpiryDate",
        "pano_id": "panoId",
        "property_bearing": "propertyBearing",
        "street_point": "streetPoint",
        "street_view_coordinates": "streetViewCoordinates",
    });
});
/** @internal */
exports.StreetView$outboundSchema = z.object({
    buildingPoint: z.nullable(coordinates_js_1.Coordinates$outboundSchema),
    distanceFromStreetPoint: z.nullable(z.number()),
    imageDate: z.nullable(z.string()),
    imageExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    panoId: z.nullable(z.string()),
    propertyBearing: z.nullable(z.number()),
    streetPoint: z.nullable(coordinates_js_1.Coordinates$outboundSchema),
    streetViewCoordinates: z.nullable(coordinates_js_1.Coordinates$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        buildingPoint: "building_point",
        distanceFromStreetPoint: "distance_from_street_point",
        imageDate: "image_date",
        imageExpiryDate: "image_expiry_date",
        panoId: "pano_id",
        propertyBearing: "property_bearing",
        streetPoint: "street_point",
        streetViewCoordinates: "street_view_coordinates",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StreetView$;
(function (StreetView$) {
    /** @deprecated use `StreetView$inboundSchema` instead. */
    StreetView$.inboundSchema = exports.StreetView$inboundSchema;
    /** @deprecated use `StreetView$outboundSchema` instead. */
    StreetView$.outboundSchema = exports.StreetView$outboundSchema;
})(StreetView$ || (exports.StreetView$ = StreetView$ = {}));
function streetViewToJSON(streetView) {
    return JSON.stringify(exports.StreetView$outboundSchema.parse(streetView));
}
function streetViewFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StreetView$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StreetView' from JSON`);
}
//# sourceMappingURL=streetview.js.map